import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function init() {
  if(!$('.modal-subscribe').length) { return false }


  ScrollTrigger.create({
    trigger: '.blog-posts-block',
    start: 'top center+=25%',
    end: 'bottom bottom',
    //markers: true,
    once: true,
    onEnter: () => {
      $('.modal-subscribe').addClass('is-visible')
    }
  })

}

init()

let $body = $('body')
$body.on('click', '.modal-backdrop, .js-modal-close', function (e) {
  e.preventDefault()

  $('.modal-subscribe ').removeClass('is-visible')

})


$body.on('submit', '#modal-subscribe-form', function(e){

  //replace button with loader
  $('.popup').hide()
  let form = $(this)
  let loader = form.find('.loader')
  let submit_button = form.find('button[type="submit"]')
  let success = $('.modal-subscribe .form-success')

  let formData = form.serialize()


  $.ajax({
    type: "POST",
    url: ajaxurl,
    data: formData,
    success: function (data) {
      form.hide()
      success.removeClass('is-hidden').show()
    }

  })

  return false

})
